// extracted by mini-css-extract-plugin
module.exports = {"starContainer":"ydxjpsQd","star":"_1yRRX686 _1m8vMwqD"};